import {
  SEND_PDF_REQUEST,
  SEND_PDF_SUCCESS,
  SEND_PDF_ERROR,
  CHECK_PDF_USAGE_ERROR,
  SAVE_PDF_SUCCESS,
  CHECK_PDF_USAGE_SUCCESS,
  CANCEL_PDF_ERROR,
  CANCEL_PDF_SUCCESS,
  SAVE_PDF_REQUEST,
  SAVE_PDF_ERROR,
  CHECK_PDF_USAGE_REQUEST,
  CANCEL_PDF_REQUEST,
  SET_UNITS_FOR_SAVE,
} from "../../../common/constants/action-constants";
import AlertService from "../../../common/services/notification.service";
import {
  IUnlinkPdfErrorAction,
  IUnlinkPdfRequestAction,
  IUnlinkPdfSuccessAction,
  IUploadedDriveFile
} from '../../../../types/google-drive.types';

export const sendPDFRequest = (data: FormData, navigate: (path: string) => void) => {
  return {
    type: SEND_PDF_REQUEST,
    data,
    navigate,
  };
};

export const sendPDFSuccess = (pdfData: any, navigate: any) => {
  return {
    type: SEND_PDF_SUCCESS,
    pdfData,
    navigate,
  };
};

export const sendPDFError = (error: any) => {
  AlertService.error("Something wrong with this file");
  return {
    type: SEND_PDF_ERROR,
    error,
  };
};

export const savePDFRequest = (data: any, navigate: any) => {
  return {
    type: SAVE_PDF_REQUEST,
    data,
    navigate,
  };
};

export const savePDFSuccess = (pdfData: any) => {
  pdfData.data && AlertService.info(pdfData.data.message);
  return {
    type: SAVE_PDF_SUCCESS,
    pdfData,
  };
};

export const savePDFError = (error: any) => {
  return {
    type: SAVE_PDF_ERROR,
    error,
  };
};

export const checkPDFUsageRequest = (pdfId: any, navigate: any) => {
  return {
    type: CHECK_PDF_USAGE_REQUEST,
    pdfId,
    navigate,
  };
};

export const checkPDFUsageSuccess = (message: any) => {
  return {
    type: CHECK_PDF_USAGE_SUCCESS,
    message,
  };
};

export const checkPDFUsageError = (error: any) => {
  return {
    type: CHECK_PDF_USAGE_ERROR,
    error,
  };
};

export const unlinkPDFRequest = ( fileForDriveImport: IUploadedDriveFile): IUnlinkPdfRequestAction => {
  return {
    type: CANCEL_PDF_REQUEST,
    fileForDriveImport,
  };
};

export const unlinkPDFSuccess = (pdfData: {}): IUnlinkPdfSuccessAction => {
  return {
    type: CANCEL_PDF_SUCCESS,
    pdfData,
  };
};

export const unlinkPDFError = (error: unknown): IUnlinkPdfErrorAction => {
  return {
    type: CANCEL_PDF_ERROR,
    error,
  };
};

export const setUnitsForSave = (unitsForSave: any) => {
  return {
    type: SET_UNITS_FOR_SAVE,
    unitsForSave,
  };
};
